export const isRecord = (value) => typeof value === 'object' &&
    value !== null &&
    (Object.getPrototypeOf(value) === Object.prototype ||
        Object.getPrototypeOf(value) === null);
export const objectOf = (fields) => {
    const predicates = fields;
    const keys = Object.keys(predicates);
    return (value) => isRecord(value) &&
        Object.keys(value).every((key) => keys.includes(key)) &&
        keys.every((key) => predicates[key](Object.prototype.hasOwnProperty.call(value, key)
            ? value[key]
            : undefined));
};
export const optional = (guard) => (value) => value === undefined || guard(value);
export const nullable = (guard) => (value) => value === null || guard(value);
export const arrayOf = (guard, maxLength) => (value) => Array.isArray(value) &&
    value.length <= maxLength &&
    Array.from(value).every(guard);
export const oneOf = (values) => (value) => values.some((item) => item === value);
export const isBoolean = (value) => typeof value === 'boolean';
export const isSchemaVersion1 = (value) => value === 1;
export const isCount = (value) => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;
export const isPositiveInteger = (value) => isCount(value) && value > 0;
export const isFiniteNumber = (value) => typeof value === 'number' && Number.isFinite(value);
export const isNonNegativeNumber = (value) => isFiniteNumber(value) && value >= 0;
export const boundedString = (maxLength, minLength = 0) => (value) => typeof value === 'string' &&
    value.length >= minLength &&
    value.length <= maxLength;
export const isUuid = (value) => typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
// 日付の形式・実在性だけを検証する。期間解決、日数、時差・比較計算は ANV2-02 の責務。
export const isDateOnly = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const date = new Date(value + 'T00:00:00Z');
    return (Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value);
};
export const isTimestamp = (value) => {
    if (typeof value !== 'string')
        return false;
    const parts = /^(\d{4}-\d{2}-\d{2})[Tt](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:[Zz]|[+-](\d{2}):(\d{2}))$/.exec(value);
    return (parts !== null &&
        isDateOnly(parts[1]) &&
        Number(parts[2]) < 24 &&
        Number(parts[3]) < 60 &&
        Number(parts[4]) < 60 &&
        (parts[5] === undefined ||
            (Number(parts[5]) < 24 && Number(parts[6]) < 60)) &&
        Number.isFinite(Date.parse(value)));
};
export const jsonFits = (value, maxBytes) => {
    try {
        const json = JSON.stringify(value);
        if (json === undefined || json.length > maxBytes)
            return false;
        let bytes = 0;
        for (const char of json) {
            const point = char.codePointAt(0);
            if (point === undefined)
                return false;
            bytes += point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4;
            if (bytes > maxBytes)
                return false;
        }
        return true;
    }
    catch {
        return false;
    }
};
/** 生値をエラーや log へ載せず、呼出側が新解析だけを skip できる結果を返す。 */
export const readVersioned = (value, guard) => {
    if (value === undefined)
        return { status: 'absent' };
    if (!isRecord(value) || !isPositiveInteger(value.schemaVersion))
        return { status: 'invalid', reason: 'shape' };
    if (value.schemaVersion !== 1)
        return { status: 'unsupported_schema', schemaVersion: value.schemaVersion };
    return guard(value)
        ? { status: 'valid', value }
        : { status: 'invalid', reason: 'shape' };
};
